'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performPublish = undefined;

var _timeout = require('q/js/lib/timeout');

var _timeout2 = _interopRequireDefault(_timeout);

var _fetchHistory = require('./fetchHistory');

var _parseAblyMessage = require('../operators/parseAblyMessage');

var _realtimeApiVersions = require('../constants/realtimeApiVersions');

var _defaults = require('../constants/defaults');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var performPublish = exports.performPublish = function performPublish(channels, publishObject) {
  return (0, _timeout2.default)(new Promise(function (resolve, reject) {
    var channel = channels.get(publishObject.channel);
    var encodedData = JSON.stringify(publishObject.message);

    channel.publish(_realtimeApiVersions.REALTIME_API_V1, encodedData, function (publishError) {
      if (publishError) {
        var error = new Error('PubSub publish failed');
        error.responseJSON = publishError;
        reject(error);
      } else {
        (0, _fetchHistory.fetchHistory)(channel).then(function (historyItems) {
          var publishedMessage = historyItems.find(function (item) {
            return item.data === encodedData;
          });

          if (!publishedMessage) {
            throw new Error('PubSub published message not found in history');
          }
          resolve((0, _parseAblyMessage.parseAblyMessage)(publishedMessage));
        }).catch(reject);
      }
    });
  }), _defaults.PROMISE_TIMEOUT_MS, 'PubSub publish timeout');
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/api-wrappers/performPublish.js
// module id = 780
// module chunks = 2 3